import { message } from 'taxaroo-ui';

const onSuccessDeleteClientFile = () => {
  message.success('File deleted');
};

const handleOnErrorDownloadFile = () => {
  message.error('An error has occurred while trying to download file. Please try again');
};

export {
  onSuccessDeleteClientFile,
  handleOnErrorDownloadFile,
};
